// extracted by mini-css-extract-plugin
export default {"linkWithUnderline":"Iv4jlL","footer":"KyeCS1","icon":"RUXqJN","text":"e0pNtn"};